import axios from 'axios'

const cedis = {
    get_cedis: (id_proyecto) => axios.get(`manager/cedis/get-cedis?id_proyecto=${id_proyecto}`),
    get_monedas: () => axios.get("monedas"),
};
export default cedis
